@if (productSection.mappings || productSection.placeholders) {
  <div class="table-scroll-wrapper">
    <table class="navinta-table">
      <thead>
        <tr>
          <th
            class="col-10"
            i18n="@@monitoring.productList.productTable.position.header"
            data-testid="monitoring.productList.productTable.column1"
          >
            Pos.
          </th>
          <th
            class="col-18"
            i18n="@@monitoring.productList.productTable.count.header"
            data-testid="monitoring.productList.productTable.column2"
          >
            Anzahl
          </th>
          <th
            class="col-auto"
            i18n="@@monitoring.productList.productTable.label.header"
            data-testid="monitoring.productList.productTable.column3"
          >
            Bezeichnung
          </th>
          <th
            class="col-20"
            i18n="@@monitoring.productList.productTable.materialNumber.header"
            data-testid="monitoring.productList.productTable.column4"
          >
            Material Nummer
          </th>
        </tr>
      </thead>
      @for (mapping of productSection.mappings; track $index) {
        <tbody>
          @for (product of mapping.data; track $index) {
            @if (product) {
              <tr [ngClass]="{ discontinued: !product.isAvailable }">
                <td>
                  {{ product.positionId + (product.isAvailable ? "" : " ") }}
                  @if (!product.isAvailable) {
                    <img src="assets/warning-colored-odx.svg" alt="warning" [odxTooltip]="tooltipTextWarningSign" />
                  }
                </td>
                <td>{{ mapping.placedProductsCount * product.quantity }}</td>
                <td>{{ product.name }}</td>
                <td>{{ product.matNr }}</td>
              </tr>
            }
          }
        </tbody>
        <tbody>
          @for (device of productSection.devices; track $index) {
            @for (product of device.products; track $index) {
              @if (product.id && productBelongsToConfig(device, mapping)) {
                <tr>
                  <td>{{ product.positionId }}</td>
                  <td>{{ placeholderWithProductsCount }}</td>
                  <td>{{ product.name || "Benutzerdefinierte MatNr." }}</td>
                  <td>{{ product.id }}</td>
                </tr>
              }
            }
          }
        </tbody>
      }
      <tbody>
        @for (placeholder of productSection.placeholders; track $index) {
          @for (product of placeholder.products; track $index) {
            @if (product.id) {
              <tr>
                <td>{{ product.positionId }}</td>
                <td>{{ placeholderWithProductsCount }}</td>
                <td>{{ product.name }}</td>
                <td>{{ product.id }}</td>
              </tr>
            }
          }
        }
        @if (placeholderWithoutProductsCount > 0) {
          <tr [ngClass]="{ 'text-red': true }">
            <td>{{ productSection.placeholderPositionPrefix }}</td>
            <td>{{ placeholderWithoutProductsCount }}</td>
            <td i18n="@@productList.placeholder.description">Platzhalter (noch zu konfigurieren)</td>
            <td>{{ "" }}</td>
          </tr>
        }
      </tbody>
    </table>
  </div>
}
